import type { ArticleHeadingLevel } from '~/content/learn';

/**
 * Vertical rhythm between body sections, by outline level: 96 / 72 / 56px.
 *
 * Legal documents already read at this rhythm while articles sat at 64px for an
 * h2 and 36px for anything nested, which is the "too little spacing between
 * sections" the marketing side reported. The rich-text migration is not the cause, it
 * carries a round-trip contract that keeps the rendered block list identical
 * (see `article-richtext-migrate.ts`), so this is the reading rhythm rather
 * than a regression.
 *
 * Shared so the two renderers cannot drift apart again, and so there is a single
 * place to nudge when the design says otherwise.
 */
export function sectionGap(level: ArticleHeadingLevel): string {
  if (level === 2) return 'mt-24';

  return level === 4 ? 'mt-14' : 'mt-18';
}
